export function isAdminRole(role: string | null | undefined): boolean {
  return typeof role === 'string' && role.trim().toUpperCase() === 'ADMIN';
}

export function isUserRole(role: string | null | undefined): boolean {
  return typeof role === 'string' && role.trim().toUpperCase() === 'USER';
}
